import styled from '@emotion/styled';

export const CustomForm = styled.form`
  margin-bottom: ${({ theme }) => theme.margin.l};
`;